// 这个文件用于定义共享变量
const sharedVariable = {
    login_status: false,
    unfinished_payment: {'qrcode_url':'', 'pay_amount':0, 'out_trade_no':''},
    unfinished_tip: {'qrcode_url':'', 'tip_amount':0, 'out_trade_no':''},
    tip_username: '',
    tip_uid: '',
    tip_nickname: ''
};

// 导出共享变量以供其他文件使用
export default sharedVariable;